import { MEDIA_TYPE } from '../../../../../../../../../Google/AdForms/fields'
import {
  AD_DESCRIPTION,
  AD_HEADLINE,
  CALL_TO_ACTION,
  CLICK_THROUGH_LINK,
  HEADLINE_ENTER,
  HEADLINE_OPTION,
  LEAD_GEN_FORM,
  PRIMARY_TEXT_LIST,
  TEXT_ENTER,
  TEXT_OPTION
} from '../../../../../../../fields'
import { IMAGE_HASH, FILE_ID, VIDEO_PICTURE } from '../../../../../../../../../ReusableFormFields/AdFileUpload/fields'

import { getUrlDomain } from '../../../../../../../../../../helpers/url'

import { CallToAction, FormattedSingleItemFeed, LineItemType } from './types'
import { SingleItemValues } from '../types'
import { LEAD_GENERATION } from '../../../../../../../../../../constants/campaigns'

export const formatSingleItemFeedToBE = (
  values: SingleItemValues,
  lineItem?: LineItemType
): FormattedSingleItemFeed => {
  const {
    [MEDIA_TYPE]: mediaType,
    [AD_HEADLINE]: adHeadline,
    [HEADLINE_OPTION]: headlineOption,
    [TEXT_OPTION]: textOption,
    [AD_DESCRIPTION]: adDescription,
    [VIDEO_PICTURE]: feedVideoPicture,
    [FILE_ID]: feedVideoId,
    [CLICK_THROUGH_LINK]: clickThroughLink,
    [IMAGE_HASH]: fileHash,
    [CALL_TO_ACTION]: callToActionChoice
  } = values

  // use first element from primary text list
  const adText = values[PRIMARY_TEXT_LIST]?.[0]?.text

  const callToAction: CallToAction = {
    type: callToActionChoice?.toLowerCase(),
    value: {
      ...(lineItem?.objective !== 'page_likes' && {
        // do not add link on this level for lineItem objective 'page_likes'
        link: clickThroughLink
      }),
      ...(lineItem?.objective === LEAD_GENERATION && { lead_gen_form_id: values[LEAD_GEN_FORM] })
    }
  }

  // MAIN FEED IS AN IMAGE
  const linkData = {
    ...(textOption === TEXT_ENTER && adText && { message: adText }),
    ...(headlineOption === HEADLINE_ENTER && { name: adHeadline }),
    ...(adDescription && { description: adDescription }),
    image_hash: mediaType === 'image' ? fileHash : undefined,
    caption: getUrlDomain(clickThroughLink),
    link: clickThroughLink,
    ...(clickThroughLink && { call_to_action: callToAction })
  }

  // MAIN FEED IS A VIDEO
  const videoData = {
    ...(textOption === TEXT_ENTER && adText && { message: adText }),
    ...(headlineOption === HEADLINE_ENTER && { title: adHeadline }),
    ...(adDescription && { link_description: adDescription }),
    image_url: mediaType === 'video' ? feedVideoPicture : undefined,
    video_id: mediaType === 'video' ? feedVideoId : undefined,
    link: clickThroughLink,
    ...(clickThroughLink && { call_to_action: callToAction })
  }

  return mediaType === 'image' ? { link_data: linkData } : { video_data: videoData }
}
